<template>
  <div>
    <Breadcrumb origin-name="Communities" origin-path="/communities" :current-name="this.fixName || `Neue ${ backofficeRole === 'super-admin' ? 'Single-' : ''}Community ${isNewCommunity ? 'anlegen' : 'bearbeiten'}`" />
    <h3 v-if="isNewCommunity">Neue {{ backofficeRole === "super-admin" ? 'Single-' : ''}}Community anlegen</h3>
    <h3 v-else>{{ backofficeRole === "super-admin" ? 'Single-' : ''}}Community bearbeiten</h3>
    <form @submit.prevent="submit">
      <div class="form-group">
        <label for="name-input">Name*</label>
        <input autofocus
               type="text"
               class="form-control"
               id="name-input"
               placeholder="Name"
               v-model="name"
               required/>
      </div>
      <div class="form-group">
        <label for="description-input">Beschreibung</label>
        <textarea class="form-control"
                  id="description-input"
                  placeholder="Beschreibung"
                  v-model="description"></textarea>
      </div>
      <div class="form-group">
        <label for="address-input">Adresse</label>
        <textarea class="form-control"
                  id="address-input"
                  placeholder="Adresse"
                  v-model="address"></textarea>
      </div>
      <div class="form-group">
        <label for="phone-input">Telefonnummer</label>
        <textarea class="form-control"
                  id="phone-input"
                  placeholder="Telefonnummer"
                  v-model="phone"></textarea>
      </div>
      <div class="form-group">
        <label for="comment-input">Kommentar</label>
        <textarea class="form-control"
                  id="comment-input"
                  placeholder="Kommentar"
                  v-model="comment"></textarea>
      </div>
      <div class="form-group">
        <label for="paymentInfo-input">Zahlungsinformation</label>
        <textarea class="form-control"
                  id="paymentInfo-input"
                  placeholder="Zahlungsinformation"
                  v-model="paymentInfo"></textarea>
      </div>
      <div class="form-group">
        <label for="latitude-input">Längengrad</label>
        <input autofocus
               type="text"
               class="form-control"
               id="latitude-input"
               placeholder="Längengrad"
               v-model="latitude"/>
      </div>
      <div class="form-group">
        <label for="longitude-input">Breitengrad</label>
        <input autofocus
               type="text"
               class="form-control"
               id="longitude-input"
               placeholder="Breitengrad"
               v-model="longitude"/>
      </div>
      <div class="form-group">
        <label for="image-input">Bild</label>
        <input autofocus
               type="file"
               class="form-control"
               id="image-input"
               title="Bild"
               placeholder="Bild"
               accept="image/png, image/jpeg, image/jpg, image/gif"
               @change="onImageSelect"/>
        <img v-if="imageUrl" class="community-image mt-3" :src="imageUrl" />
      </div>
      <div v-if="createdAt">Erstellt am {{ createdAt | dateFormat }}</div>
      <div class="hint mb-3">* Pflichtfeld</div>
      <button class="btn btn-primary" :class="{disabled: loading}">
        {{ isNewCommunity ? "Anlegen" : "Speichern" }}
        <span v-if="loading" class="spinner"></span>
      </button>
      <button @click.prevent="toggleDialogVisible = true" v-if="!isNewCommunity && backofficeRole !== 'community-manager'" class="btn btn-danger delete-button" :class="{disabled: loading}">
        {{ active ? "Deaktivieren" : "Aktivieren" }}
        <span v-if="loading" class="spinner"></span>
      </button>
    </form>
    <Dialog :visible="toggleDialogVisible"
            :title="active ? 'Deaktivieren?' : 'Aktivieren?'"
            :ok-button-text="`Ja, ${active ? 'deaktivieren' : 'aktivieren'}!`"
            @cancel="toggleDialogVisible = false"
            @ok="toggleCommunity"
            :message="`Wollen Sie die ${backofficeRole === 'super-admin' ? 'Single-' : ''}Community ${active ? 'deaktivieren' : 'aktivieren'}?`">
    </Dialog>
  </div>
</template>

<script>
import {communicator} from "@/util/communicator.js";
import {broadcast} from "@/util/eventHandler.js";
import Dialog from "@/components/partial/Dialog.vue";
import Breadcrumb from "@/components/partial/Breadcrumb.vue";
import {getBackofficeRole} from "@/util/authenticator";

export default {
  components: {Breadcrumb, Dialog},
  name: "CommunityEditor",
  data() {
    return {
      backofficeRole: "",
      fixName: "",
      name: "",
      description: "",
      address: "",
      phone: "",
      comment: "",
      paymentInfo: "",
      latitude: "",
      longitude: "",
      image: undefined,
      imageUrl: "",
      createdAt: "",
      communityId: undefined,
      active: false,
      loading: false,
      toggleDialogVisible: false,
      isNewCommunity: false
    };
  },
  watch: {
    latitude() {
      if(!this.latitude) return;
      this.latitude = (this.latitude + "").replace(",", ".");
    },
    longitude() {
      if(!this.longitude) return;
      this.longitude = (this.longitude + "").replace(",", ".");
    }
  },
  created() {
    if(this.$route.params.id) {
      const community = this.$store.state.communities.find(e => String(e.id) === this.$route.params.id);
      this.mapCommunity(community);
    }
    else this.isNewCommunity = true;
    this.backofficeRole = getBackofficeRole();
  },
  methods: {
    onImageSelect(event) {
      if (event.target.files.length !== 1) return;
      this.image = event.target.files[0];
    },
    mapCommunity(community) {
      this.fixName = community.name || "";
      this.name = community.name || "";
      this.description = community.description || "";
      this.address = community.address || "";
      this.phone = community.phone || "";
      this.comment = community.comment || "";
      this.paymentInfo = community.paymentInfo || "";
      this.latitude = community.latitude || "";
      this.longitude = community.longitude || "";
      this.createdAt = community.createdAt || "";
      this.communityId = community.id;
      this.imageUrl = community.imageUrl || "";
      this.active = community.active || false;
    },
    async submit() {
      if(this.loading) return;
      try {
        this.loading = true;
        const data = {
          name: this.name,
          latitude: Number(this.latitude),
          longitude: Number(this.longitude),
          description: this.description,
          address: this.address,
          phone: this.phone,
          comment: this.comment,
          paymentInfo: this.paymentInfo
        };
        if(this.communityId) {
          data.id = this.communityId;
        }
        const response = await communicator[this.isNewCommunity ? "post" : "put"]("/communities", data);
        if(!this.communityId) {
          this.communityId = response.data.id;
        }
        await this.uploadImage();
        if(this.isNewCommunity) this.$router.push("/communities");
        else {
          this.fixName = this.name;
          broadcast("tab-changed");
        }
        console.log("[AddCommunity] Got response: ", response);
        broadcast("community-changed", data);
      } catch (e) {
        broadcast("error", e.response.data);
      }
      this.loading = false;
    },

    async uploadImage() {
      if (!this.image || !this.communityId) return;
      let data = new FormData();
      data.append("file", this.image);
      const response = await communicator.post(`/communities/${this.communityId}/image`, data);
      console.log("[AddCommunity] Got response: ", response);
    },

    openDeleteDialog() {
      this.deleteDialogVisible = true;
    },

    async toggleCommunity() {
      console.log("Disable: ", this.community);
      if(this.loading) return;
      this.loading = true;
      this.toggleDialogVisible = false;
      try {
        await communicator.put("/communities/", {
          id: this.communityId,
          name: this.name,
          active: !this.active
        });
        this.$router.push("/communities");
      } catch (e) {
        broadcast("error", e.response.data);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.community-image {
  max-width: 300px;
}
.delete-button {
  margin-left: 1rem;
  display: inline-block;
}
</style>
